import React from "react";
import FooterTop from "./FooterTop";
import FooterBottom from "./FooterBottom";

const Footer = () => {
  return (
    <div className="lg:mt-[0rem] mt-[4rem]">
      <div className="relative">
      <div className = "md:relative absolute md:w-auto w-full md:top-[176px] top-[-6px]">
        <FooterTop />
      </div>
      <div>
        <FooterBottom />
      </div>
      </div>
    </div>
  );
};

export default Footer;
